import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
import vuexI18n from 'vuex-i18n'

import users from "./users.module"
import courses from "./courses.module"
import auth from "./auth.module";
import stripe from "./stripe.module"
import translations from "./translations.module"
import globals from "./global.module"
import modules from './modules.module'
import languages from "./languages.module"
import equipment from "./equipment.module"
import roles from "./roles.module"
import groups from "./groups.module"
import documents from "./documents.module"
import pages from './pages.module'
import companysettings from './companysettings.module'
import dashboard from './dashboard.module'
import reminderemail from './reminderemail.module'
import videotutorial from './videotutorial.module'
import equipmentgroups from './equipmentgroups.module'
import equipmenttemplate from './equipmenttemplate.module'
import testcasegroup from './testcasegroup.module'
import testcasetemplate from './testcasetemplate.module'
import equipmentlabels from './equipmentlabels.module'
import testcase from './testcase.module'

import translationsEn from '../locale/en'
import translationsDe from '../locale/de'


Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    users,
    auth,
    courses,
    stripe,
    documents,
    pages,
    groups,
    languages,
    equipment,
    companysettings,
    equipmentgroups,
    equipmenttemplate,
    equipmentlabels,
    testcase,
    roles,
    modules,    
    translations,
    globals,
    testcasegroup,
    testcasetemplate,
    videotutorial,
    reminderemail,
    dashboard
  }
})


Vue.use(vuexI18n.plugin, store);
Vue.i18n.add('en', translationsEn)
Vue.i18n.add('de', translationsDe)

export default store